import {AfterViewInit, ChangeDetectorRef, Component, OnDestroy, OnInit, ViewChild,} from "@angular/core";
import {
  AutocompleteLoadingModeType,
  DatepickerDayComponent,
  IAutocompleteSchema,
  IDatepickerSchema,
  ISelectOneSchema,
  ToastService,
} from "maps-angular-components";
import {BehaviorSubject, Subject, Subscription} from "rxjs";
import {FormBuilder, FormControl, FormGroup} from "@angular/forms";
import {DatePipe} from "@angular/common";
import {HttpErrorResponse} from "@angular/common/http";
import {LogErroComponent} from "../log-erro/log-erro.component";
import {MatCheckboxChange} from "@angular/material/checkbox";
import {MatDialog} from "@angular/material/dialog";
import {ModalConfirmComponent} from "src/app/shared/components/modal-confirm/modal-confirm.component";
import {PageService} from "../../shared/layout/services/page.service";
import {Processamento} from "../processamento/processamento";
import {ProcessamentoService} from "../processamento.service";
import {finalize} from "rxjs/operators";
import {listaStatusProcessamento} from "../processamento/status-processamento.model";
import {ModalDetalheProcessamentoComponent} from "../../shared/modal-detalhe-processamento/modal-detalhe-processamento.component";
import {ModalUltimosDezProcessamentoComponent} from "../../shared/modal-ultimos-dez-processamento/modal-ultimos-dez-processamento.component";
import {DetalheProcessamentoFilter} from "../../shared/modal-detalhe-processamento/detalhe-processamento-filter";
import {indicate} from "../../shared/util/loading-indicate";
import {BrowserSupport} from "../../shared/util/browser-support";
import { CarteiraAutocompleteModel } from "../../carteira/carteira.model";
import { CarteiraGrupoAutocompleteService } from "src/app/carteira/carteira-grupo-autocomplete.service";
import { SelectableActionsState } from "src/app/shared/state/selectable-actions-state";
import { ProcessamentoPeriodoModalComponent } from "../processamento-periodo-modal/processamento-periodo-modal.component";

@Component({
  selector: "app-processamento-pesquisa",
  templateUrl: "./processamento-pesquisa.component.html",
  styleUrls: ["./processamento-pesquisa.component.scss"],
  providers: [DatePipe],
})
export class ProcessamentoPesquisaComponent
  implements OnInit, AfterViewInit, OnDestroy
{
  private readonly subscriptions = new Subscription();
  pageNumber$: Subject<number> = new Subject<number>();
  pageSize: number = 20;
  totalSelecionados$: BehaviorSubject<number> = new BehaviorSubject<number>(0);
  status = listaStatusProcessamento;
  processamentos: Processamento[] = [];
  paginationTotalPage = 1;
  public totalRegistros = 0;
  public isLoading = false;
  public isProcessando = false;
  public autoRefresh = true;
  public allCheck = false;
  private selectedOptions: number[] = [];
  private selectedProcessamentosMap = new Map<number, Processamento>();
  interval;

  loadingExport$: Subject<boolean> = new Subject<boolean>();

  @ViewChild("dataProcessamento", { static: false })
  dataProcessamento: DatepickerDayComponent;

  html = "";

  form: FormGroup;
  carteiraSchema: IAutocompleteSchema<CarteiraAutocompleteModel>;
  dataProcessarSchema: IDatepickerSchema;
  ultimaDataEnquadramentoSchema: IDatepickerSchema;
  statusSchema: ISelectOneSchema;

  constructor(
    public formBuilder: FormBuilder,
    private readonly carteiraGrupoAutocompleteService: CarteiraGrupoAutocompleteService,
    private readonly processamentoService: ProcessamentoService,
    private readonly changeDetectorRef: ChangeDetectorRef,
    private readonly messageService: ToastService,
    private readonly page: PageService,
    private readonly dialog: MatDialog,
    private readonly datePipe: DatePipe
  ) {}

  private readonly smallInput = "small-input";
  private cancelar = new SelectableActionsState();

  ngOnInit() {
    this.page.defineTitle("PROCESSAMENTO");

    this.form = this.formBuilder.group({
      carteiraId: new FormControl(),
      dataUltimoProcessamento: new FormControl(),
      dataProcessamento: new FormControl(),
      status: new FormControl(),
      page: new FormControl(0),
    });

    this.carteiraSchema = {
      service: this.carteiraGrupoAutocompleteService,
      label: "",
      placeholder: "",
      loadingMode: AutocompleteLoadingModeType.LAZY,
      autoload: false,
      endpoint: "",
      formGroup: this.form,
      formControlName: "carteiraId",
      panelClass: "large-input",
      parseSearchParam(search): string {
        return search;
      },
    };

    this.ultimaDataEnquadramentoSchema = {
      formControlName: "dataUltimoProcessamento",
      formGroup: this.form,
      label: "Última data processamento",
      placeholder: "Selecione a data",
      panelClass: this.smallInput,
    };

    this.dataProcessarSchema = {
      formControlName: "dataProcessamento",
      formGroup: this.form,
      label: "Data processamento",
      placeholder: "Selecione a data",
      panelClass: this.smallInput,
    };

    this.statusSchema = {
      label: "Status",
      placeholder: "",
      formControlName: "status",
      formGroup: this.form,
      panelClass: this.smallInput,
    };
  }

  searchEvent(pageNumber: number) {
    this.pageNumber$.next(pageNumber);
  }

  get cancelandoTodas$() {
    return this.cancelar.all$;
  }

  get cancelandoSelecionadas$() {
    return this.cancelar.selected$;
  }

  btnPesquisar() {
    this.selectedProcessamentosMap.clear();
    this.allCheck = false;
    this.selectedOptions = [];
    this.totalSelecionados$.next(0);

    this.searchEvent(1);
    this.form.controls.page.setValue(0);
    this.pesquisar(this.form.value);
  }

  pesquisar(value: any) {
    this.isLoading = true;

    this.totalRegistros = 0;
    this.processamentos = [];

    this.subscriptions.add(
      this.processamentoService
        .search(value, this.pageSize)
        .pipe(finalize(() => (this.isLoading = false)))
        .subscribe(
          (res) => {
            if (res.metadata.totalElements > 0) {
              if (res.metadata.size === 0) {
                this.paginationTotalPage = 1;
              } else {
                this.paginationTotalPage = Math.ceil(
                  res.metadata.totalElements / res.metadata.size
                );
              }
              this.totalRegistros = res.metadata.totalElements;
              this.processamentos = res.content.map(e =>
                Object.assign(new Processamento(), e, {
                  check: this.selectedOptions.includes(e.carteiraId)
                })
              );
              this.updateAllChecked();

              this.form.get("page").setValue(res.metadata.number);
            } else {
              this.paginationTotalPage = 1;
            }
            this.isLoading = false;
          },
          (err) => this.messageService.erro(err.error.message),
          () => this.changeDetectorRef.detectChanges()
        )
    );
  }

  showDetailsLogErro(p: Processamento) {
    this.dialog.open(LogErroComponent, {
      data: p,
      minWidth: "80vw",
      maxWidth: "80vw",
      maxHeight: "99vh",
      autoFocus: false,
    });
  }

  showDetails(p: Processamento) {
    this.dialog.open(ModalDetalheProcessamentoComponent, {
      data: new  DetalheProcessamentoFilter(p.carteiraId,p.ultimaDataProcessamento,p.ultimaDataProcessamento),
      minWidth: "80vw",
      maxWidth: "80vw",
      maxHeight: "99vh",
      autoFocus: false,
    });
  }

  confirmDialog(p: Processamento) {
    this.dialog.open(ModalUltimosDezProcessamentoComponent, {
      data: p.carteiraId,
      minWidth: "80vw",
      maxWidth: "80vw",
      maxHeight: "99vh",
      autoFocus: false,
    });
  }

  receiverPage(value) {
    this.form.controls.page.setValue(value - 1);
    this.searchEvent(value);
    this.pesquisar(this.form.value);
  }

  updatePageSize(pageSize: number) {
    this.pageSize = pageSize;
    this.btnPesquisar();
  }

  confirmarConfirmarProcessamentoTodas() {
    const dialogRef = this.dialog.open(ModalConfirmComponent, {
      data: {
        title: 'Tem certeza?',
        message: 'Deseja processar todas as '+ this.totalRegistros +' carteiras filtradas?',
        confirmText: 'Processar',
        cancelText: 'Cancelar'
      },
      width: "500px",
      maxHeight: "50vh",
      autoFocus: false,
    });

    dialogRef.afterClosed().subscribe(confirm => {
      dialogRef.close();
      if (confirm) {
        this.executarProcessamentoTodas();
      }
    })
  }

  executarProcessamentoTodas() {
    let erro = false;
    if (this.form.value.dataProcessamento === null) {
      this.messageService.alerta("Data processamento não selecionada.");
      erro = true;
    }
    if (!erro) {
      this.isProcessando = true;
      this.processamentoService
        .executarProcessamentoFiltradas(this.form.value)
        .subscribe(
          () => {},
          (err: HttpErrorResponse) => {
            this.messageService.erro(err.error.message);
          },
          () => {
            this.isProcessando = false;
            this.changeDetectorRef.detectChanges();
          }
        );
      if (this.autoRefresh) this.updateStatus();
    }
  }

  executarProcessamento(value: any) {
    let erro = false;
    if (value.dataProcessamento === null) {
      this.messageService.alerta("Data processamento não selecionada.");
      erro = true;
    }
    if (!erro) {
      this.isProcessando = true;
      let checked = this.getProcessamentosSelecionados().map(p => p.carteiraId)
      if(checked.length > 0){
        this.subscriptions.add(
          this.processamentoService
            .executarProcessamento(value, checked)
            .subscribe(
              () => {},
              (err: HttpErrorResponse) => {
                this.messageService.erro(err.error.message);
              },
              () => {
                this.processamentos.forEach(p => p.check = false)
                this.isProcessando = false;
                this.changeDetectorRef.detectChanges();
              }
            )
        );
        if (this.autoRefresh) this.updateStatus();
      }
    }
    this.form.get("dataProcessamento").setValue(null);
    this.dataProcessamento.reset();
    this.changeDetectorRef.detectChanges();
    this.allCheck = false;
    this.processamentos.forEach((element) => {
      element.check = false;
      this.checkboxChange(false, element.carteiraId);
    });
  }

  ngAfterViewInit(): void {
    this.interval = setInterval(() => {
      if (this.autoRefresh) this.updateStatus();
    }, 1000);
  }

  private updateStatus() {
    this.subscriptions.add(
      this.processamentoService.search(this.form.value, this.pageSize).subscribe(
        res => {
          this.processamentos.forEach((item) => {
            const _item = res.content.find(
              (p) => p.carteiraId === item.carteiraId
            );

            if (!_item) return;

            item.statusProcessamento = _item.statusProcessamento;
            item.ultimaDataProcessamento = _item.ultimaDataProcessamento;
          });

          this.changeDetectorRef.detectChanges();
        },
        err => this.messageService.erro(err.error.message)
      )
    );
  }

  processarPeriodo() {
    let dialogRef = this.dialog.open(ProcessamentoPeriodoModalComponent, {
      minWidth: '90vw',
      data: {
        processamentosSelecionados: this.getProcessamentosSelecionados(),
        totalProcessamentos: this.totalRegistros,
        filter: this.form.value
      }
    });
    dialogRef.componentInstance.processamentoSuccess.subscribe(() => {
      this.messageService.sucesso("Carteiras enviadas para processamento");
      dialogRef.close();
      this.btnPesquisar();
    })
  }

  getProcessamentosSelecionados(): Processamento[] {
    return Array.from(this.selectedProcessamentosMap.values());
  }

  cancelarSelecionadas() {
    const qtdCarteirasSelecionadas = this.getProcessamentosSelecionados().length;

    const mensagem = qtdCarteirasSelecionadas === 1
      ? 'Deseja confirmar o cancelamento do processamento da carteira selecionada?'
      : `Deseja confirmar o cancelamento do processamento de todas as ${qtdCarteirasSelecionadas} carteiras selecionadas?`;

    const dialogRef = this.dialog.open(ModalConfirmComponent, {
      data: {
        title: 'Confirmar cancelamento',
        message: mensagem,
        confirmText: 'Confirmar',
        cancelText: 'Cancelar'
      },
      width: "500px",
      maxHeight: "50vh",
      autoFocus: false,
    });

    dialogRef.afterClosed().subscribe(confirm => {
      dialogRef.close();
      if (confirm) {
        this.processamentoService.cancelarProcessamento(this.getProcessamentosSelecionados().map(p => p.carteiraId))
        .subscribe(
          () => {
            this.messageService.sucesso("Carteiras enviadas para cancelamento")
          },
          (err: HttpErrorResponse) => {
            this.messageService.erro(err.error.message);
          },
          () => {
            this.changeDetectorRef.detectChanges();
          }
        );
        if (this.autoRefresh) this.updateStatus()
      }
    })
  }

  cancelarTodas() {
    const dialogRef = this.dialog.open(ModalConfirmComponent, {
      data: {
        title: 'Confirmar cancelamento',
        message: 'Deseja confirmar o cancelamento do processamento de todas as '+ this.totalRegistros +' carteiras filtradas?',
        confirmText: 'Confirmar',
        cancelText: 'Cancelar'
      },
      width: "500px",
      maxHeight: "50vh",
      autoFocus: false,
    });

    dialogRef.afterClosed().subscribe(confirm => {
      dialogRef.close();
      if (confirm) {
        this.processamentoService.cancelarProcessamentoTodas(this.form.value)
        .subscribe(
          () => {
            this.messageService.sucesso("Carteiras enviadas para cancelamento")
          },
          (err: HttpErrorResponse) => {
            this.messageService.erro(err.error.message);
          },
          () => {
            this.changeDetectorRef.detectChanges();
          }
        );
        if (this.autoRefresh) this.updateStatus()
      }
    })
  }

  ngOnDestroy(): void {
    if (this.interval) {
      clearInterval(this.interval);
    }
    this.subscriptions.unsubscribe();
  }

  desabilitarProcessamento(value) {
    return value.dataProcessamento === null || this.isProcessamentoSelecionado();
  }

  private isProcessamentoSelecionado() {
    let desabilitarProcessamento = true;
    for (const processamento of this.processamentos) {
      if (processamento.check) {
        desabilitarProcessamento = false;
      }
    }
    return desabilitarProcessamento;
  }

  selectAll($event: MatCheckboxChange) {
    if ($event.checked) {
      this.processamentos
        .filter((item) => !this.selectedOptions.includes(item.carteiraId))
        .forEach((item) => {
          item.check = true;
          this.selectedOptions.push(item.carteiraId);
          this.selectedProcessamentosMap.set(item.carteiraId, item);
        });
    } else {
      this.processamentos
        .filter((item) => this.selectedOptions.includes(item.carteiraId))
        .forEach((item) => {
          item.check = false;
          const index = this.selectedOptions.indexOf(item.carteiraId);
          if (index > -1) this.selectedOptions.splice(index, 1);
          this.selectedProcessamentosMap.delete(item.carteiraId);
        });
    }

    this.totalSelecionados$.next(this.selectedOptions.length);
  }

  checkboxChange(checked: boolean, id: number) {
    const itemSelecionado = this.processamentos.find(p => p.carteiraId === id);

    if (checked === true) {
      this.selectedOptions.push(id);
      if (itemSelecionado) {
        this.selectedProcessamentosMap.set(id, itemSelecionado);
      }
    } else {
      const index: number = this.selectedOptions.indexOf(id);
      if (index !== -1) {
        this.selectedOptions.splice(index, 1);
      }
      this.selectedProcessamentosMap.delete(id);
    }

    this.updateAllChecked();
  }

  updateAllChecked() {
    this.allCheck = this.processamentos.length > 0 && this.processamentos.every(p => p.check)
    this.totalSelecionados$.next(this.selectedOptions.length);
  }

  verificaDataEnquadramento(dataEnquadramento: Date) {
    if (dataEnquadramento === null) {
      return "-";
    }
    return this.datePipe.transform(dataEnquadramento, "dd/MM/yyyy");
  }

  allSelected(): boolean {
    return (
      this.selectedOptions.length === this.processamentos.length &&
      this.processamentos.length > 0
    );
  }

  exportarPdf() {
    this.subscriptions.add(
      this.processamentoService.exportPdf(this.form.value).pipe(indicate(this.loadingExport$)).subscribe(data => {
        BrowserSupport.savePDF(data);
      }, err => this.messageService.erro(err.error.message)));
  }

  exportarXls() {
    this.subscriptions.add(
      this.processamentoService.exportXlsx(this.form.value).pipe(indicate(this.loadingExport$)).subscribe(data => {
        BrowserSupport.saveXlsx(data);
      }, err => this.messageService.erro(err.error.message)));
  }
}
